import styled from "@emotion/styled";
import { Affix, Button } from "antd";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

interface FooterCreateAgentProps {
  loading: boolean;
}
const FooterCreateAgent: FC<FooterCreateAgentProps> = ({ loading }) => {
  const navigate = useNavigate();
  return (
    <Affix offsetBottom={0}>
    <WrapperAll>
      <ButtonWrapper>
      <Button size="large" danger onClick={() => {
        navigate('/manage-agent');
      }} style={{ width: "100%", marginRight:'5px' }}>
        ยกเลิก
      </Button>
        <Button
          loading={loading}
          htmlType="submit"
          type="primary"
          style={{ width: 200 }}
        size="large"
        >
          บันทึก
        </Button>
      </ButtonWrapper>
    </WrapperAll>
  </Affix>
  );
};

export default FooterCreateAgent;

const ButtonWrapper = styled.div`
  max-width: 250px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;

const WrapperAll = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 10px;
  background-color: #fff;
  border-radius: 4px;
`;
